import InputCheckboxText from "./Input.Checkbox.Text";

export default InputCheckboxText;